module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_IS-079044b9b745be1472c76c97d273c675.svg";